import { Box, type BoxProps } from '@chakra-ui/react';

export function FormPanel({
  children,
  mt,
}: {
  children?: React.ReactNode;
  mt?: BoxProps['mt'];
}) {
  return (
    <Box
      w="full"
      as="fieldset"
      border="2px solid"
      rounded="md"
      borderColor="snap.teal.100"
      pb={4}
      mt={mt}
    >
      {children}
    </Box>
  );
}
